import { render, staticRenderFns } from "./QuoteReceivedList.vue?vue&type=template&id=15f6e4c4&"
import script from "./QuoteReceivedList.vue?vue&type=script&lang=js&"
export * from "./QuoteReceivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports